import { deletePlayerId } from 'api/notifications';
import Cookies from 'js-cookie';
import { cookiesTokenName } from 'utils/helper';
import { create } from 'zustand';
import useGlobalStore from './useGlobalStore';

const useAuthStore = create((set, get) => ({
  // User profile data
  profile: null,
  // Authentication state
  isAuthenticated: false,
  token: null,
  notificationsBadgeCount: 0,

  // Actions
  setProfile: (userData) => {
    set({
      profile: userData,
      isSuperAdmin: userData?.is_superuser === 1 ? true : false,
      isAuthenticated: true
    })
  },
  setPermissions: (perms) => set({
    permissions: perms
  }),

  setToken: (token) => set({
    token: token
  }),

  setNotificationsBadgeCount: (count) => set({ notificationsBadgeCount: count }),

  logout: async () => {
    await deletePlayerId()
    set({ token: null });
    Cookies.remove(cookiesTokenName, { path: '/' });
    setTimeout(() => {
      set({
        profile: null,
        isAuthenticated: false,
        notificationsBadgeCount: 0,
      });
      useGlobalStore.getState().clearStore();
    }, 500);
  }
}))

export default useAuthStore
